import React from 'react'

const JobSeekerDescription = ({ row }) => {

  const capitalizeFirstLetter = (word) => {
    return word?.replace(
      /<p>(.*?)<\/p>/,
      (match, p1) =>
        `<p className="text-light">${p1.charAt(0).toUpperCase()}${p1.slice(
          1
        )}</p>`
    );
  };

  return (
    <div className="card detail-card border border-primary rounded p-2">
      <div
        className={`text-start mb-0`}
        dangerouslySetInnerHTML={{
          __html: capitalizeFirstLetter(
            row?.description
          ),
        }}
      ></div>
    </div>
  )
}

export default JobSeekerDescription